/** A deletion visit gets a fresh app lifetime without game sync or save writers. */
export function isAccountDeletionPath(path: string): boolean {
  return path.replace(/\/+$/, '') === '/delete-account'
}

export const ACCOUNT_DELETION_SESSION = typeof window !== 'undefined'
  && isAccountDeletionPath(window.location.pathname)

/** Prefix sweep includes old saves, per-account parked runs, pending wallet earns,
 * Starweave retries and future account caches. Firebase Auth persistence is
 * removed by signOut separately. Unrelated applications' storage is untouched. */
export function clearAccountStorage(storage: Pick<Storage, 'length' | 'key' | 'removeItem'>): void {
  for (let i = storage.length - 1; i >= 0; i--) {
    const key = storage.key(i)
    if (key?.startsWith('elemental-dispatch-')) storage.removeItem(key)
  }
}
